import { render, staticRenderFns } from "./SellerViewer.vue?vue&type=template&id=28dd6c3d&"
import script from "./SellerViewer.vue?vue&type=script&lang=js&"
export * from "./SellerViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports